// extracted by mini-css-extract-plugin
module.exports = {"bar":"BarChart_bar__35ede","bars":"BarChart_bars__1Drcf"};